import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import {
  format,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  isToday,
  isSameMonth,
  isSameDay,
  eachDayOfInterval,
} from "date-fns";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchEventImage,
  fetchScheduleCategory,
  fetchSpecificEvent,
  resetCreateEvent,
  updateEvent,
} from "../redux/slices/userSlice";
import ClipLoader from "react-spinners/ClipLoader";
import { toast } from "react-toastify";
import CohostModal from "./CohostModal";

const EventRap = styled.div`
  background: #ffffff;
  border-radius: 20px;
  padding: 30px;
  .events h4 {
    color: #060b13;
    font-size: 14px;
    font-weight: 400;
    padding: 15px;
    padding-bottom: 25px;
    background: #060b130a;
    border: 1px solid #bac0d499;
    max-width: 430px;
    border-radius: 15px;
  }
  .all-events h2 {
    color: #060b13;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 15px;
  }
  /* .events p {
    padding: 15px;
    border-radius: 100px;
    background: #060b130a;
    border: 1px solid #bac0d499;
    width: 430px;
    margin-bottom: 20px;
  } */
  /* .event-links {
  display: flex;
  align-items: center;
  border-radius: 100px;
    background: #060b130a;
    border: 1px solid #bac0d499;
    width: 430px;
  padding: 15px;
  gap: 5px;
  overflow: hidden; 
} */

  /* .event-links p {
  color: #363d4f;
  font-weight: 400;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
} */

  .event-links {
    display: flex;
    background: #060b130a;
    border-radius: 100px;
    border: 1px solid #bac0d499;
    background: #060b130a;
    padding: 15px;
    border: 1px solid #bac0d499;
    align-items: center;
    gap: 8px;
    width: 430px;
    padding: 10px;
  }
  .event-linker {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .label {
    color: #363d4f;
    font-weight: 400;
    font-size: 14px;
    white-space: nowrap;
  }

  .scroll-container {
    overflow: hidden;
    width: 300px; /* adjust width as needed */
    white-space: nowrap;
    position: relative;
  }

  .scrolling-text {
    display: inline-block;
    padding-left: 100%;
    color: #ed1c24;
    animation: scroll-text 30s linear infinite;
  }

  @keyframes scroll-text {
    from {
      transform: translateX(0%);
    }
    to {
      transform: translateX(-100%);
    }
  }

  /* .event-links {
    display: flex;
    align-items: center;
    gap: 5px;

  } */
  .event-links-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border: 1px solid #bac0d499;
    border-radius: 50%;
  }
  .event-links-sent {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .delete-button,
  .edit-button,
  .stream-button {
    border-top: 1px;
    border-right: 4px;
    border-bottom: 4px;
    border-left: 1px;
    border-radius: 100px;
    background: #ffffff;
    padding: 12px 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-style: solid;
    color: #060b13;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    border-color: #060b13;
  }
  .edit-button,
  .stream-button {
    background: #ed1c24;
    color: #ffffff;
  }
  .event-buttons {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    flex-wrap: wrap;
  }
  .all-events {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }
  .events {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
  }
  .event-image-div {
    width: 80%;
    min-height: 460px;
    border-radius: 20px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .event-sub {
    width: fit-content;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .event-sub {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .timezone p {
    color: #828286;
    font-size: 12px;
    font-weight: 400;
  }
  .timezone p a {
    text-decoration: none;
    color: #ed1c24;
  }
  .timezone {
    position: relative;
  }
  .timezone-dropdown {
    padding: 0;
    border: 1px solid #ddd;
    border-radius: 15px;
    width: 300px;
    background: #ffffff;
    position: absolute;
    z-index: 9999;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  .time-input,
  .calendar-container input {
    width: 210px;
    height: 50px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 15px;
    border: 0.8px solid #bac0d4b2;

    font-weight: 400;
    font-size: 12px;
  }
  .time-dropdown {
    border: 0.6px solid #d0d5dd;
    box-shadow: 0px 8px 22px 0px #2230491a;
    width: 207px;
    background: #ffffff;
    padding: 20px;
    margin-top: 10px;
    padding-right: 10px;
    border-radius: 10px;
    position: absolute;
    z-index: 1000;
  }
  .time-dropdown p {
    color: #060b13;
    font-weight: 400;
    text-align: center;
    font-size: 12px;
  }
  .time-dropdown-div {
    max-height: 240px;
    overflow-y: scroll;
    padding: 5px 10px;
  }
  .time-dropdown-div::-webkit-scrollbar {
    width: 6px;
  }

  .time-dropdown-div::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  .time-dropdown-div::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .time-dropdown-div::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .time-dropdown-div::-webkit-scrollbar-button {
    display: none;
  }
  .the-time {
    padding: 10px;
    cursor: pointer;
    border-radius: 6px;
    color: #060b13;
    font-weight: 500;
    font-size: 12px;
  }
  .time-cancel {
    border: none;
    color: #060b13;
    font-size: 14px;
    font-weight: 400;
    background: #ffffff;
  }
  .time-save {
    background: #ed1c24;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    border: none;
    width: 66px;
    height: 32px;
    border-radius: 8px;
  }
  .calendar-container {
    position: relative;
    max-width: 344px;
  }

  .calendar-dropdown {
    position: absolute;
    top: 50px;
    right: 20%;
    background: white;
    border: 0.6px solid #d0d5dd;
    border-radius: 10px;
    padding: 15px;
    margin-top: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    max-width: 344px;
    z-index: 10;
  }

  .calendar-header {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 10px;
    color: #1e1e1c;
    font-size: 14px;
    font-weight: 400;
  }

  .calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
  }

  .calendar-day {
    padding: 10px;
    text-align: center;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    color: #1e1e1c;
    font-weight: 400;
  }

  .today {
    color: #ed1c24;
  }

  .selected {
    background: #ed1c24;
    color: white;
    border-radius: 50%;
  }

  .other-month {
    color: #828280;
  }
  .start-date-time {
    display: flex;
    gap: 10px;
  }
  .category-input {
    width: 430px;
    height: 50px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0px;
    border-radius: 100px;
    border: 0.8px solid #bac0d4b2;
  }
  .category-input p {
    color: #060b13;
    font-weight: 400;
    font-size: 14px;
    padding: 0px 15px;
  }
  .category {
    position: relative;
  }
  .category-dropdown {
    border: 0.6px solid #d0d5dd;
    box-shadow: 0px 8px 22px 0px #2230491a;
    background: #ffffff;
    width: 430px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    gap: 15px;
    padding: 10px;
    z-index: 9999;
    position: absolute;
    margin-top: 10px;
  }
  .category-dropdown p {
    color: #060b13;
    font-weight: 400;
    font-size: 14px;
    padding: 10px;
  }
  .category-dropdown p:hover {
    background: #e8e9eb;
    border-radius: 6px;
  }
  input,
  textarea {
    border: 0.8px solid #bac0d4b2;
    width: 430px;
    height: 50px;
    border-radius: 100px;
    color: #060b13;
    font-weight: 400;
    font-size: 14px;
    padding-left: 15px;
  }
  .custom-radio {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #060b13;
  }

  .custom-radio input[type="radio"] {
    display: none; /* Hide default radio button */
  }

  .radio-checkmark {
    height: 20px;
    width: 20px;
    border: 2px solid red;
    border-radius: 50%;
    margin-right: 10px;

    position: relative;
  }

  .custom-radio input[type="radio"]:checked + .radio-checkmark {
    background-color: transparent;
  }

  .custom-radio input[type="radio"]:checked + .radio-checkmark:before {
    content: "";
    position: absolute;
    top: 3px;
    left: 3px;
    height: 10px;
    width: 10px;
    background-color: red;
    border-radius: 50%;
  }

  .upload-img-div {
    display: inline-block;
    padding: 8px 16px;
    background: #e8e9eb;

    color: #060b13 !important;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 400;
  }
  .fileInput {
    display: none;
  }
  .tap-to-upload h6 {
    font-size: 14px;
    color: #171717;
    font-weight: 500;
  }
  .file-upload {
    width: 201px;
    height: 83px;

    justify-content: center;
    display: flex;
    gap: 16px;
    border-radius: 15px;
    align-items: center;
    border: 0.8px solid #bac0d4b2;
  }
  .tap-to-upload p {
    font-size: 12px;
    color: #9499ac;
    font-family: "Inter";
  }
  .uploadedImage {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .uploadedImage p {
    font-weight: 400;
    max-width: 201px;
    font-size: 12px;
    color: #828286;
  }
  .uploadedImage-default {
    max-width: 201px;
    height: 83px;
    border-radius: 5px;
  }
  .add-uploaded-divs {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
  .all-dropdown-div {
    max-width: 500px;
    max-height: 546px;
    background: #ffffff;
    border-radius: 16px;
  }
  .schedule-btn {
    border-top: 1px;
    border-right: 4px;
    border-bottom: 4px;
    border-left: 1px;
    border-style: solid;
    width: 430px !important;
    height: 50px !important;
    border-radius: 100px;
    padding: 12px;
    background: #ed1c24;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    border-color: #060b13;
  }

  .delete-div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    width: 500px;
    height: 276px;
  }
  .delete-div p {
    color: #828286;
    max-width: 257px;
    line-height: 20px;
    font-size: 12px;
    text-align: center;
    font-weight: 400;
  }
  .delete-div h4 {
    color: #060b13;
    font-size: 18px;
    font-weight: 500;
  }
  .move-back-icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0.7px solid #828286;
  }
  .events-head {
    display: flex;

    gap: 10px;
  }

  @media (max-width: 1024px) {
    .event-buttons {
      flex-wrap: wrap;
      justify-content: flex-start;
    }
  }

  @media (max-width: 768px) {
    padding: 20px;

    .events h4 {
      max-width: 100% !important;
    }
    .event-image-div {
      width: 100%;
    }
    .event-links,
    .category-input,
    input,
    textarea,
    .schedule-btn {
      width: 100% !important;
    }

    .start-date-time,
    .event-buttons,
    .event-links-sent {
      flex-direction: column;
      align-items: stretch;
    }
  }

  @media (max-width: 480px) {
    .event-links {
      padding: 12px;
    }
    .event-links {
      width: 350px !important;
    }
    .event-buttons button {
      width: 100%;
      justify-content: center;
    }
  }

  @media (max-width: 400px) {
    .event-links {
      width: 300px !important;
    }
  }
  @media (max-width: 350px) {
    .event-links {
      width: 260px !important;
    }
  }
`;

const EventsDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const {
    sheduleCategory,
    specificEvent,
    eventSuccess,
    userChannel,
    userEvents,
    eventloading,
    userData,
    loading,
    error,
    eventImages,
  } = useSelector((state) => state.userData);

  const channelId = localStorage.getItem("pluglrUserChannelId");

  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedTimezone, setSelectedTimezone] = useState(
    "(GMT+01:00) West Central Africa"
  );
  const [popScheduleLates, setPopScheduleLater] = useState(false);
  const [showTimeDropdown, setShowTimeDropdown] = useState(false);
  const [selectedTime, setSelectedTime] = useState("Start Time");
  const [tempTime, setTempTime] = useState(selectedTime);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [showEndCalendar, setShowEndCalendar] = useState(false);
  const currentMonth = new Date();
  console.log(selectedTime);
  console.log(selectedDate);

  const [timeMenuOpen, setTimeMenuOpen] = useState(false);

  const [chosenTime, setChosenTime] = useState("End Time");

  const [highlightedTime, setHighlightedTime] = useState("");
  const [showCategory, setShowCategory] = useState(false);
  const [selectedOption, setSelectedOption] = useState("default");
  const [uploadedImage, setUploadedImage] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("Select Category");
  const [showDeleteEvent, setShowDeleteEvent] = useState(false);
  const [showCohostModal, setShowCohostModal] = useState(false);
  const timezones = [
    "(GMT-08:00) Pacific Time (US & Canada)",
    "(GMT-05:00) Eastern Time (US & Canada)",
    "(GMT+00:00) Greenwich Mean Time",
    "(GMT+01:00) West Central Africa",
    "(GMT+05:30) India Standard Time",
    "(GMT+08:00) Singapore Time",
  ];

  const [formData, setFormData] = useState({
    title: "",
    id: id,
    start: "",
    end: "",
    category: "",
    description: "",
  });

  console.log(specificEvent);
  console.log(formData);

  const startTime = specificEvent?.data?.startTime;
  const endTime = specificEvent?.data?.endTime; // example value

  const formatDateTime = (timestamp) => {
    const dateObj = new Date(timestamp);

    // Time: 01:00 AM
    const time = dateObj.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    // Date: August 4th, 2025
    const day = dateObj.getDate();
    const month = dateObj.toLocaleString("en-US", { month: "long" });
    const year = dateObj.getFullYear();

    // Add ordinal suffix (st, nd, rd, th)
    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return "th"; // 11th, 12th, 13th...
      switch (n % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    const date = `${month} ${day}${getOrdinal(day)}, ${year}`;

    return { time, date };
  };

  const start = formatDateTime(startTime);
  const end = formatDateTime(endTime);

  useEffect(() => {
    if (id && !eventImages?.[id]) {
      dispatch(fetchEventImage(id));
    }
  }, [dispatch, id, eventImages]);

  const defaultEventImage = "/images/image_1.png";
  const eventBackgroundImage = eventImages?.[id] ?? defaultEventImage;

  const eventHeroBackground = useMemo(
    () =>
      `linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0) 20.95%,
        rgba(0, 0, 0, 0.659617) 81.51%,
        #000000 103.25%
      ), url('${eventBackgroundImage}')`,
    [eventBackgroundImage]
  );

  console.log("Start Time:", start.time); // 01:00 AM
  console.log("Start Date:", start.date); // August 4th, 2025
  console.log("End Time:", end.time); // 03:00 AM
  console.log("End Date:", end.date); // August 4th, 2025

  // Instead of saving strings, save actual Date objects
  useEffect(() => {
    if (specificEvent) {
      const startObj = new Date(startTime);
      const endObj = new Date(endTime);

      setSelectedTime(formatDateTime(startTime).time);
      setChosenTime(formatDateTime(endTime).time);

      setSelectedDate(startObj); // ✅ keep as Date object
      setSelectedEndDate(endObj); // ✅ keep as Date object
    }
  }, [specificEvent]);

  useEffect(() => {
    if (specificEvent) {
      setFormData((prev) => ({
        ...prev,
        title: specificEvent?.data?.title,
        description: specificEvent?.data?.description,
        category: specificEvent?.data?.category,
      }));
      setSelectedCategory(specificEvent?.data?.category);
    }
  }, [specificEvent]);

  useEffect(() => {
    if (id) {
      dispatch(fetchSpecificEvent(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    dispatch(fetchScheduleCategory());
  }, [dispatch]);

  useEffect(() => {
    if (selectedTime !== "Start Time" && selectedDate !== null) {
      // Parse time string (e.g. "01:00 PM")
      const [time, modifier] = selectedTime.split(" ");
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier === "PM" && hours !== 12) hours += 12;
      if (modifier === "AM" && hours === 12) hours = 0;

      // Create combined Date object
      const combinedDate = new Date(selectedDate);
      combinedDate.setHours(hours);
      combinedDate.setMinutes(minutes);
      combinedDate.setSeconds(0);
      combinedDate.setMilliseconds(0);

      // Convert to timestamp
      const timestamp = combinedDate.getTime();

      // Update formData with the timestamp
      setFormData((prev) => ({
        ...prev,
        start: timestamp,
      }));
    }
  }, [selectedTime, selectedDate]);

  useEffect(() => {
    if (chosenTime !== "End Time" && selectedEndDate !== null) {
      // Parse time string (e.g. "01:00 PM")
      const [time, modifier] = chosenTime.split(" ");
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier === "PM" && hours !== 12) hours += 12;
      if (modifier === "AM" && hours === 12) hours = 0;

      // Create combined Date object
      const combinedDate = new Date(selectedEndDate);
      combinedDate.setHours(hours);
      combinedDate.setMinutes(minutes);
      combinedDate.setSeconds(0);
      combinedDate.setMilliseconds(0);

      // Convert to timestamp
      const timestamp = combinedDate.getTime();

      // Update formData with the timestamp
      setFormData((prev) => ({
        ...prev,
        end: timestamp,
      }));
    }
  }, [chosenTime, selectedEndDate]);

  useEffect(() => {
    if (selectedCategory !== "Select Category") {
      setFormData((prev) => ({
        ...prev,
        category: selectedCategory,
      }));
    }
  }, [selectedCategory]);

  const handleShowDeleteEvent = () => {
    setShowDeleteEvent(!showDeleteEvent);
  };
  const handleShowCategory = () => {
    setShowCategory((prev) => !prev);
  };

  const handleSelectCategory = (category) => {
    setSelectedCategory(category); // Update the selected category
    setShowCategory(false); // Close the dropdown
  };

  const handleTimezoneChange = (timezone) => {
    setSelectedTimezone(timezone);
    setShowDropdown(false); // Close the dropdown after selection
  };
  // Generate time options in 12-hour format
  const generateTimes = () => {
    const times = [];
    for (let hour = 1; hour <= 12; hour++) {
      for (let minutes = 0; minutes < 60; minutes += 1) {
        const formattedHour = hour.toString().padStart(2, "0");
        const formattedMinutes = minutes.toString().padStart(2, "0");
        times.push(`${formattedHour}:${formattedMinutes} AM`);
        times.push(`${formattedHour}:${formattedMinutes} PM`);
      }
    }
    return times;
  };

  const times = generateTimes();

  const handleTimeChange = (time) => {
    setTempTime(time);
  };

  const saveTime = () => {
    setSelectedTime(tempTime);
    setShowTimeDropdown(false);
  };

  const daysInMonth = eachDayOfInterval({
    start: startOfMonth(currentMonth),
    end: endOfMonth(currentMonth),
  });

  const handleDateClick = (date) => {
    setSelectedDate(new Date(date));
    setShowCalendar(false);
  };

  const handleEndDateClick = (date) => {
    setSelectedEndDate(new Date(date));
    setShowEndCalendar(false);
  };

  const renderHeader = () => {
    const daysOfWeek = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
    return (
      <div className="calendar-header">
        {daysOfWeek.map((day) => (
          <div key={day} className="day-label">
            {day}
          </div>
        ))}
      </div>
    );
  };

  const renderDays = () => {
    const startDate = startOfWeek(startOfMonth(currentMonth));
    const endDate = endOfWeek(endOfMonth(currentMonth));

    return eachDayOfInterval({ start: startDate, end: endDate }).map((day) => {
      const isCurrentMonth = isSameMonth(day, currentMonth);
      const isTodayDate = isToday(day);
      const isSelected = selectedDate && isSameDay(day, selectedDate);

      return (
        <div
          key={day.toISOString()}
          onClick={() => handleDateClick(day)}
          className={`calendar-day 
                      ${isTodayDate ? "today" : ""} 
                      ${isSelected ? "selected" : ""} 
                      ${!isCurrentMonth ? "other-month" : ""}
                  `}
        >
          {format(day, "d")}
        </div>
      );
    });
  };

  const renderEndHeader = () => {
    const daysOfWeek = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
    return (
      <div className="calendar-header">
        {daysOfWeek.map((day) => (
          <div key={day} className="day-label">
            {day}
          </div>
        ))}
      </div>
    );
  };
  const renderEndDays = () => {
    const startDate = startOfWeek(startOfMonth(currentMonth));
    const endDate = endOfWeek(endOfMonth(currentMonth));

    return eachDayOfInterval({ start: startDate, end: endDate }).map((day) => {
      const isCurrentMonth = isSameMonth(day, currentMonth);
      const isTodayDate = isToday(day);
      const isSelected = selectedEndDate && isSameDay(day, selectedEndDate);

      return (
        <div
          key={day.toISOString()}
          onClick={() => handleEndDateClick(day)}
          className={`calendar-day 
                      ${isTodayDate ? "today" : ""} 
                      ${isSelected ? "selected" : ""} 
                      ${!isCurrentMonth ? "other-month" : ""}
                  `}
        >
          {format(day, "d")}
        </div>
      );
    });
  };

  // Function to generate times in the desired format
  const createTimeOptions = () => {
    const timeOptions = [];
    for (let hour = 1; hour <= 12; hour++) {
      for (let minute = 0; minute < 60; minute++) {
        const formattedHour = hour.toString().padStart(2, "0");
        const formattedMinute = minute.toString().padStart(2, "0");
        timeOptions.push(`${formattedHour}:${formattedMinute} AM`);
        timeOptions.push(`${formattedHour}:${formattedMinute} PM`);
      }
    }
    return timeOptions;
  };

  // Generate the time options
  const availableTimes = createTimeOptions();

  const updateTimeSelection = (time) => {
    setHighlightedTime(time);
  };

  const confirmTimeSelection = () => {
    setChosenTime(highlightedTime);
    setTimeMenuOpen(false);
  };

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setUploadedImage(e.target.result); // Set the uploaded image
      };
      reader.readAsDataURL(file);
    }
  };

  const handlePopScheduleLater = () => {
    setPopScheduleLater(!popScheduleLates);
  };

  const handleCloseEventCreate = () => {
    dispatch(resetCreateEvent());
    setPopScheduleLater(false);
  };

  const handleGoToDetails = () => {
    navigate("/users/events");
  };

  const handleStartStreaming = () => {
    if (!channelId) {
      toast.error(
        "Channel information not found. Please create a channel first."
      );
      return;
    }

    if (!id) {
      toast.error("Event information is incomplete.");
      return;
    }

    navigate(`/liveshow/${channelId}/${id}`);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(updateEvent(formData));
  };

  return (
    <EventRap>
      <div className="all-events">
        <div>
          <div className="events-head">
            <div onClick={handleGoToDetails} className="move-back-icon">
              <Icon
                icon="iconamoon:arrow-left-2-light"
                width="18"
                height="18"
                style={{ color: "#363D4F", cursor: "pointer" }}
              />
            </div>
            <h2>Event details</h2>
          </div>

          <div className="events">
            <div
              className="event-image-div"
              style={{ backgroundImage: eventHeroBackground }}
            ></div>
            <div className="event-sub">
              <p>{specificEvent?.data?.category}</p>
              <h4>{specificEvent?.data?.description} </h4>
              <div className="event-links-sent">
                <div className="event-links">
                  <p className="label">Event link:</p>
                  <div className="scroll-container">
                    <span className="scrolling-text">
                      {specificEvent?.data?.audioUrl}
                    </span>
                  </div>
                </div>
                <div className="event-linker">
                  <div className="event-links-icon">
                    <Icon
                      icon="basil:facebook-solid"
                      width="16"
                      height="16"
                      style={{ color: "#060B13", cursor: "pointer" }}
                    />
                  </div>
                  <div className="event-links-icon">
                    <Icon
                      icon="ri:linkedin-fill"
                      width="16"
                      height="16"
                      style={{ color: "#060B13", cursor: "pointer" }}
                    />
                  </div>
                  <div className="event-links-icon">
                    <Icon
                      icon="mdi:twitter"
                      width="16"
                      height="16"
                      style={{ color: "#060B13", cursor: "pointer" }}
                    />
                  </div>
                </div>
              </div>
              <div className="event-buttons">
                <button
                  onClick={handleStartStreaming}
                  className="stream-button"
                >
                  <Icon
                    icon="mdi:radio"
                    width="18"
                    height="18"
                    style={{ color: "#ffffff", cursor: "pointer" }}
                  />
                  Start streaming
                </button>
                <button
                  onClick={handleShowDeleteEvent}
                  className="delete-button"
                >
                  <Icon
                    icon="hugeicons:delete-01"
                    width="18"
                    height="18"
                    style={{ color: "#060B13", cursor: "pointer" }}
                  />
                  Delete
                </button>
                <button
                  onClick={handlePopScheduleLater}
                  className="edit-button"
                >
                  <Icon
                    icon="solar:pen-line-duotone"
                    width="18"
                    height="18"
                    style={{ color: "#ffffff", cursor: "pointer" }}
                  />
                  Edit event
                </button>
                <button
                  onClick={() => setShowCohostModal(true)}
                  className="edit-button"
                  style={{ background: "#060B13" }}
                >
                  <Icon
                    icon="mdi:account-group"
                    width="18"
                    height="18"
                    style={{ color: "#ffffff", cursor: "pointer" }}
                  />
                  Cohosts
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showCohostModal && (
        <CohostModal
          onClose={() => setShowCohostModal(false)}
          eventId={id}
          currentCohosts={specificEvent?.data?.cohosts || []}
        />
      )}
      <div>
        {popScheduleLates ? (
          <div className="dropdown-container">
            <div className="all-dropdown-div">
              <div className="dropdown-header">
                <h4>Schedule for later</h4>
                <Icon
                  onClick={handlePopScheduleLater}
                  icon="mdi:times"
                  width="16"
                  height="16"
                  style={{ color: "#828286", cursor: "pointer" }}
                />
              </div>
              <div className="dropdown-div">
                <div>
                  <input
                    className="schedules-inputs"
                    type="text"
                    placeholder="Event title"
                    value={formData.title} // bind the input value to state
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        title: e.target.value, // update only the title field
                      }))
                    }
                  />
                </div>
                {/* <div className="timezone">
                  <p>
                    Current timezone: {selectedTimezone}{" "}
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowDropdown(!showDropdown);
                      }}
                    >
                      Change the zone
                    </a>
                  </p>

                  {showDropdown && (
                    <ul
                      className="timezone-dropdown"
                      style={{
                        listStyleType: "none",
                      }}
                    >
                      {timezones.map((zone, index) => (
                        <li
                          key={index}
                          onClick={() => handleTimezoneChange(zone)}
                          style={{
                            padding: "10px",
                            cursor: "pointer",
                          }}
                          onMouseEnter={(e) =>
                            (e.target.style.backgroundColor = "#f0f0f0")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.backgroundColor = "white")
                          }
                        >
                          {zone}
                        </li>
                      ))}
                    </ul>
                  )}
                </div> */}
                <div className="start-date-time">
                  <div>
                    <div
                      onClick={() => setShowTimeDropdown(!showTimeDropdown)}
                      className="time-input"
                    >
                      <span>{selectedTime}</span>
                      <span></span>
                    </div>

                    {showTimeDropdown && (
                      <div className="time-dropdown">
                        <p style={{ fontWeight: "bold" }}>Select time</p>
                        <div className="time-dropdown-div">
                          {times.map((time, index) => (
                            <div
                              className="the-time"
                              key={index}
                              onClick={() => handleTimeChange(time)}
                              style={{
                                border:
                                  tempTime === time
                                    ? "0.7px solid #BAC0D499"
                                    : "none",
                              }}
                              onMouseEnter={(e) =>
                                (e.target.style.border =
                                  "0.7px solid #BAC0D499")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.border =
                                  tempTime === time
                                    ? "0.7px solid #BAC0D499ue"
                                    : "none")
                              }
                            >
                              {time}
                            </div>
                          ))}
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: "10px",
                          }}
                        >
                          <button
                            onClick={() => setShowTimeDropdown(false)}
                            className="time-cancel"
                          >
                            Cancel
                          </button>
                          <button onClick={saveTime} className="time-save">
                            Save
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    style={{ position: "relative" }}
                    className="calendar-container"
                  >
                    {/* Date Input */}
                    <input
                      type="text"
                      value={selectedDate ? format(selectedDate, "PPP") : ""}
                      placeholder="Start Date"
                      readOnly
                      onClick={() => setShowCalendar(!showCalendar)}
                    />

                    {/* Calendar Dropdown */}
                    {showCalendar && (
                      <div className="calendar-dropdown">
                        {renderHeader()}
                        <div className="calendar-grid">{renderDays()}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="start-date-time">
                  <div
                    className="event-date-time"
                    style={{ maxWidth: "344px" }}
                  >
                    {/* Time Selector */}
                    <div>
                      <div
                        onClick={() => setTimeMenuOpen(!timeMenuOpen)}
                        className="time-input"
                      >
                        <span>{chosenTime}</span>
                      </div>

                      {timeMenuOpen && (
                        <div
                          className="time-dropdown"
                          style={{
                            padding: "10px",
                            border: "0.6px solid #D0D5DD",
                          }}
                        >
                          <p style={{ fontWeight: "bold" }}>Select time</p>
                          <div
                            className="time-dropdown-div"
                            style={{ maxHeight: "150px", overflowY: "scroll" }}
                          >
                            {availableTimes.map((timeOption, index) => (
                              <div
                                className="the-time"
                                key={index}
                                onClick={() => updateTimeSelection(timeOption)}
                                style={{
                                  padding: "10px",
                                  border:
                                    highlightedTime === timeOption
                                      ? "0.7px solid #BAC0D499"
                                      : "none",
                                  cursor: "pointer",
                                }}
                                onMouseEnter={(e) =>
                                  (e.target.style.border =
                                    "0.7px solid #BAC0D499")
                                }
                                onMouseLeave={(e) =>
                                  (e.target.style.border =
                                    highlightedTime === timeOption
                                      ? "0.7px solid #BAC0D499"
                                      : "none")
                                }
                              >
                                {timeOption}
                              </div>
                            ))}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: "10px",
                            }}
                          >
                            <button
                              onClick={() => setTimeMenuOpen(false)}
                              className="time-cancel"
                            >
                              Cancel
                            </button>
                            <button
                              onClick={confirmTimeSelection}
                              className="time-save"
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="calendar-container">
                    {/* Date Input */}
                    <input
                      type="text"
                      value={
                        selectedEndDate ? format(selectedEndDate, "PPP") : ""
                      }
                      placeholder="End Date"
                      readOnly
                      onClick={() => setShowEndCalendar(!showEndCalendar)}
                    />

                    {/* Calendar Dropdown */}
                    {showEndCalendar && (
                      <div className="calendar-dropdown">
                        {renderEndHeader()}
                        <div className="calendar-grid">{renderEndDays()}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="category">
                  <div onClick={handleShowCategory} className="category-input">
                    <p>{selectedCategory}</p>{" "}
                  </div>
                  {showCategory && (
                    <div className="category-dropdown">
                      {JSON.parse(sheduleCategory?.data).map(
                        (category, index) => (
                          <p
                            key={index}
                            onClick={() => handleSelectCategory(category)}
                          >
                            {category}
                          </p>
                        )
                      )}
                    </div>
                  )}
                </div>
                <div>
                  <textarea
                    className="schedules-inp"
                    style={{
                      height: "120px",
                      borderRadius: "15px",
                      textAlign: "start",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                    }}
                    type="text"
                    placeholder="Event Description"
                    value={formData.description} // bind the input value to state
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        description: e.target.value, // update only the title field
                      }))
                    }
                  />
                </div>
                <div className="add-uploaded-divs">
                  <div>
                    <label className="custom-radio">
                      <input
                        type="radio"
                        value="default"
                        checked={selectedOption === "default"}
                        onChange={handleRadioChange}
                      />
                      <span className="radio-checkmark"></span>
                      Use default theme
                    </label>

                    <label className="custom-radio">
                      <input
                        type="radio"
                        value="upload"
                        checked={selectedOption === "upload"}
                        onChange={handleRadioChange}
                      />
                      <span className="radio-checkmark"></span>
                      Upload image
                    </label>
                  </div>

                  {selectedOption === "default" && (
                    <div>
                      <img
                        className="uploadedImage-default"
                        src="/images/image_1.png" // Replace with your default image URL
                        alt="Default Theme"
                        style={{
                          width: "300px",
                          height: "150px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>
                  )}

                  {selectedOption === "upload" && (
                    <div>
                      {!uploadedImage ? (
                        <div className="uploadedImage">
                          <div className="file-upload">
                            <label className="upload-img-div">
                              Choose Image
                              <input
                                onChange={handleImageUpload}
                                type="file"
                                accept="image/*"
                                className="fileInput"
                              />
                            </label>
                          </div>
                          <p>
                            JPG or PNG accepted, Max size 10mb. (Default size:
                            1400x800)
                          </p>
                        </div>
                      ) : (
                        <img
                          className="uploadedImage-default"
                          src={uploadedImage}
                          alt="Uploaded"
                          style={{
                            width: "300px",
                            height: "150px",
                            border: "1px solid #ccc",
                          }}
                        />
                      )}
                    </div>
                  )}
                </div>
                <button onClick={handleSubmit} className="schedule-btn">
                  {" "}
                  {eventloading ? (
                    <ClipLoader color="white" size={40} />
                  ) : (
                    "Schedule event"
                  )}
                </button>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <div>
        {showDeleteEvent ? (
          <div className="dropdown-container">
            <div className="all-dropdown-div">
              <div className="delete-div">
                <h4>Successful</h4>
                <p>
                  You have successfully edited schedule Tech summit 2024 event
                  for later{" "}
                </p>
                <div className="event-buttons">
                  <button
                    onClick={() => setShowDeleteEvent(false)}
                    className="delete-button"
                  >
                    Cancel
                  </button>
                  <button className="edit-button">See details</button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      {eventSuccess ? (
        <div className="dropdown-container">
          <div className="all-dropdown-div">
            <div className="dropdown-div">
              <p
                style={{
                  margin: "auto",
                  fontSize: "20px",
                  maxWidth: "300px",
                  fontWeight: "600",
                  paddingBottom: "30px",
                }}
              >
                {eventSuccess?.message}
              </p>
              <button onClick={handleCloseEventCreate} className="schedule-btn">
                CLOSE
              </button>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </EventRap>
  );
};

export default EventsDetails;
